import _ from 'lodash';

// export function calculateLevelOfIndebtedness (info, credits) {
//     $info.level_indebtedness = Number(((_.sumBy(credits, 'monthly_payment') / info.income) * 100).toFixed(2));
// }

export function sortLoanAmount (a, b) {
    if (a[1] === b[1]) {
        return 0;
    } else {
        return (a[1] < b[1]) ? -1 : 1;
    }
}

export function sortInterestRate (a, b) {
    if (a[3] === b[3]) {
        return 0;
    } else {
        return (a[3] > b[3]) ? -1 : 1;
    }
}

export function PMT (ir, np, pv, fv = 0) {
    let presentValueInterestFactor = Math.pow((1 + ir), np);
    return ir * pv * (presentValueInterestFactor + fv) / (presentValueInterestFactor - 1);
}

export function numberFormatterDefault (number) {
    return Number(number.toFixed(2));
}

export function numberFormatter (number) {
    return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
}

export function numberFormatterNoDecimal (number) {
    return new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(number);
}

export function numberFocusOut (number) {
    $(number).val(function (index, value) {
        if (value !== '') {
            if (value.indexOf(',') > -1) {
                return value.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1,$2').replace(/\B(?=(\d{3})+(?!\d)\.?)/g, '.');
            } else {
                var newvalue = new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value.replace('.', ''));
                return newvalue.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1,$2').replace(/\B(?=(\d{3})+(?!\d)\.?)/g, '.');
            }
        }
    });
}

export function numberPointReplace (number) {
    return parseFloat(number.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'));
}

export function calculateCredit (credits, credit, amount_money_paid_once, amount_money_paid_monthly, to_pay_monthly) {
    let longest_credit = _.maxBy(credits, 'duration');
    let max_duration = longest_credit.duration;

    if (credit.interest_rate === 0) {
        credit.interest_rate_annually = 0;
        credit.remaining_to_pay = credit.loan_amount;
    } else {
        credit.interest_rate_annually = credit.interest_rate / 1200;
        credit.remaining_to_pay = credit.monthly_payment * credit.duration;
    }

    let sold = credit.loan_amount;
    let start_sold;
    let sold_optimized = credit.loan_amount;
    let start_sold_optimized;

    let additional_payments = amount_money_paid_once;
    let irregular_payments = [];

    for (let i = 0; i < max_duration; i++) {
        // console.log('i ' + i);

        irregular_payments[i] = 0;
        if (amount_money_paid_monthly > 0) {
            irregular_payments[i] = amount_money_paid_monthly;
        }

        if (to_pay_monthly > 0) {
            let current_total_per_month = _.sumBy(credits, function (c) { return c.monthly_total_optimized[i];});
            // console.log('to_pay_monthly ' + to_pay_monthly);
            // console.log('current_total_per_month ' + current_total_per_month);
            if (current_total_per_month < to_pay_monthly) {
                irregular_payments[i] = to_pay_monthly - current_total_per_month;
            }

        }
        // console.log('irregular_payments ' + irregular_payments[i]);

        if (i < credit.duration) {
            if (typeof credit.monthly_total === 'undefined') {
                credit.monthly_total = [];
                credit.monthly_principal = [];
                credit.monthly_interest = [];

                credit.monthly_total_optimized = [];
                credit.monthly_principal_optimized = [];
                credit.monthly_interest_optimized = [];
            }

            if (credit.interest_rate === 0) {
                credit.monthly_interest[i] = 0;
                credit.monthly_interest_optimized[i] = 0;
            } else {
                credit.monthly_interest[i] = sold * credit.interest_rate_annually;
                credit.monthly_interest_optimized[i] = sold_optimized * credit.interest_rate_annually;
            }

            credit.monthly_principal[i] = credit.monthly_payment - credit.monthly_interest[i];
            credit.monthly_principal_optimized[i] = credit.monthly_payment - credit.monthly_interest_optimized[i];

            sold -= credit.monthly_principal[i];
            start_sold = sold + credit.monthly_principal[i];

            if (sold > 0) {
                credit.monthly_total[i] = credit.monthly_payment;
            } else {
                credit.monthly_total[i] = start_sold + credit.monthly_interest[i];
                credit.monthly_principal[i] = start_sold;
            }

            sold_optimized -= credit.monthly_principal_optimized[i] + additional_payments + irregular_payments[i];
            start_sold_optimized = sold_optimized + credit.monthly_principal_optimized[i] + additional_payments + irregular_payments[i];

            if (sold_optimized > 0) {
                credit.monthly_total_optimized[i] = credit.monthly_payment + additional_payments + irregular_payments[i];
            } else {
                credit.monthly_total_optimized[i] = start_sold_optimized + credit.monthly_interest_optimized[i];
                credit.monthly_principal_optimized[i] = start_sold_optimized;
            }

            additional_payments = 0;

            if (credit.monthly_total_optimized[i] < 0) {
                credit.monthly_total_optimized[i] = 0;
                credit.monthly_principal_optimized[i] = 0;
                credit.monthly_interest_optimized[i] = 0;
            }

        } else {
            credit.monthly_total[i] = 0;
            credit.monthly_total_optimized[i] = 0;
            credit.monthly_principal[i] = 0;
            credit.monthly_principal_optimized[i] = 0;
            credit.monthly_interest[i] = 0;
            credit.monthly_interest_optimized[i] = 0;
        }
    }

    return credit;
}

export function calculateMonths (info, credits) {
    let credits_sorted = [];

    if (info.payment_option_credit === 'smallest_credit') {
        credits_sorted = _.orderBy(credits, ['loan_amount'], ['asc']);
    } else if (info.payment_option_credit === 'biggest_interest') {
        credits_sorted = _.orderBy(credits, ['interest_rate'], ['desc']);
    }

    credits_sorted.forEach(function (credit, index) {
        let additional_payments = 0;
        let irregular_payments = 0;

        if (index === 0) {
            if (info.payment_option === 'once') {
                additional_payments = info.amount_money_paid_once;
            } else if (info.payment_option === 'monthly') {
                irregular_payments = info.amount_money_paid_monthly;
            }
        }

        credits_sorted[index] = calculateCredit(credits_sorted, credit, additional_payments, irregular_payments, 0);

        // if (credit.interest_rate === 0) {
        //     credit.interest_rate_annually = 0;
        //     credit.remaining_to_pay = credit.loan_amount;
        // } else {
        //     credit.interest_rate_annually = credit.interest_rate / 1200;
        //     credit.remaining_to_pay = credit.monthly_payment * credit.duration;
        // }
        //
        // let sold = credit.loan_amount;
        // let start_sold;
        // let sold_optimized = credit.loan_amount;
        // let start_sold_optimized;
        //
        // for (let i = 0; i < max_duration; i++) {
        //     irregular_payments[i] = 0;
        //     if (index === 0 && info.payment_option === 'monthly') {
        //         irregular_payments[i] = info.amount_money_paid_monthly;
        //     }
        //
        //     if (i < credit.duration) {
        //         if (typeof credit.months === 'undefined') {
        //             credit.months = [];
        //             credit.months_return = [];
        //
        //             credit.monthly_total = [];
        //             credit.monthly_principal = [];
        //             credit.monthly_interest = [];
        //
        //             credit.monthly_total_optimized = [];
        //             credit.monthly_principal_optimized = [];
        //             credit.monthly_interest_optimized = [];
        //         }
        //
        //         if (credit.interest_rate === 0) {
        //             credit.monthly_interest[i] = 0;
        //             credit.monthly_interest_optimized[i] = 0;
        //         } else {
        //             credit.monthly_interest[i] = sold * credit.interest_rate_annually;
        //             credit.monthly_principal[i] = credit.monthly_payment - credit.monthly_interest[i];
        //
        //             credit.monthly_interest_optimized[i] = sold_optimized * credit.interest_rate_annually;
        //             credit.monthly_principal_optimized[i] = credit.monthly_payment - credit.monthly_interest_optimized[i];
        //
        //             sold -= credit.monthly_principal[i];
        //             start_sold = sold + credit.monthly_principal[i];
        //
        //             if (sold > 0) {
        //                 credit.monthly_total[i] = credit.monthly_payment;
        //             } else {
        //                 credit.monthly_total[i] = start_sold + credit.monthly_interest[i];
        //                 credit.monthly_principal[i] = start_sold;
        //             }
        //
        //             sold_optimized -= credit.monthly_principal_optimized[i] + additional_payments + irregular_payments[i];
        //             start_sold_optimized = sold_optimized + credit.monthly_principal_optimized[i] + additional_payments + irregular_payments[i];
        //
        //             if (sold_optimized > 0) {
        //                 credit.monthly_total_optimized[i] = credit.monthly_payment + additional_payments + irregular_payments[i];
        //             } else {
        //                 credit.monthly_total_optimized[i] = start_sold_optimized + credit.monthly_interest_optimized[i];
        //                 additional_payments = 0;
        //                 credit.monthly_principal_optimized[i] = start_sold_optimized;
        //             }
        //
        //             if (credit.monthly_total_optimized[i] < 0) {
        //                 credit.monthly_total_optimized[i] = 0;
        //                 credit.monthly_principal_optimized[i] = 0;
        //                 credit.monthly_interest_optimized[i] = 0;
        //             }
        //         }
        //
        //     } else {
        //         credit.months[i] = 0;
        //         credit.months_return[i] = 0;
        //         credit.monthly_total[i] = 0;
        //         credit.monthly_total_optimized[i] = 0;
        //         credit.monthly_principal[i] = 0;
        //         credit.monthly_principal_optimized[i] = 0;
        //         credit.monthly_interest[i] = 0;
        //         credit.monthly_interest_optimized[i] = 0;
        //     }
        // }

        credit.duration_optimized = _.filter(credit.monthly_total_optimized, function (a) { return a > 0;}).length;
    });

    return credits_sorted;
}

export function calculate (info, credits) {
    credits = calculateMonths(info, credits);

    // let longest_credit = _.maxBy(credits, 'duration');
    // let max_duration = longest_credit.duration;

    let to_pay_monthly = _.sumBy(credits, function (c) { return c.monthly_payment; });
    if (info.payment_option === 'monthly') {
        to_pay_monthly += info.amount_money_paid_monthly;
    }

    // console.log(to_pay_monthly);

    credits.forEach(function (credit, index) {
        if (index > 0) {
            credits[index] = calculateCredit(credits, credit, 0, 0, to_pay_monthly);
            credit.duration_optimized = _.filter(credit.monthly_total_optimized, function (a) { return a > 0;}).length;
        }
    });

    // for (let i = 0; i < max_duration; i++) {
    //     let month_total = _.sumBy(credits, 'monthly_payment');
    //     console.log(month_total);
    //
    //     if (info.payment_option === 'monthly') {
    //         month_total += info.amount_money_paid_monthly;
    //     }
    //     console.log(month_total);
    //     credits.forEach(function (credit, index) {
    //         if (index > 0) {
    //
    //             credits[index] = calculateCredit(credit, 0, 0, to_pay_monthly);
    //
    //             let sold_optimized = credit.loan_amount;
    //             let start_sold_optimized;
    //
    //             let return_value = 0;
    //             if (sold_optimized > 0) {
    //
    //                 credit.duration_optimized = i + 1;
    //
    //                 sold_optimized -= credit.monthly_principal[i] + month_total;
    //
    //                 let current_total_per_month = _.sumBy(credits, function (c) { return c.monthly_total_optimized[i]; });
    //
    //                 console.log(current_total_per_month);
    //
    //                 if (i > 0 && current_total_per_month < month_total) {
    //                     credit.monthly_total_optimized[i] += (month_total - current_total_per_month);
    //
    //                     if (credit.monthly_total_optimized[i] > 0) {
    //                         credit.monthly_interest_optimized[i] = credit.remaining_to_pay * credit.interest_rate_annually;
    //                     } else {
    //                         credit.monthly_interest_optimized[i] = 0;
    //                     }
    //
    //                     start_sold_optimized = sold_optimized + credit.monthly_principal_optimized[i] + additional_payments + irregular_payments[i];
    //
    //                     if (sold_optimized > 0) {
    //                         credit.monthly_total_optimized[i] = credit.monthly_payment + additional_payments + irregular_payments[i];
    //                     } else {
    //                         credit.monthly_total_optimized[i] = start_sold_optimized + credit.monthly_interest_optimized[i];
    //                         additional_payments = 0;
    //                         credit.monthly_principal_optimized[i] = start_sold_optimized;
    //                     }
    //
    //                     credit.remaining_to_pay -= (month_total - current_total_per_month);
    //                 }
    //
    //                 if (credit.remaining_to_pay < 0) {
    //                     return_value = Math.abs(credit.remaining_to_pay);
    //                     credit.monthly_total_optimized[i] -= return_value;
    //                     credit.remaining_to_pay = 0;
    //                 }
    //             } else {
    //                 credit.monthly_total_optimized[i] = 0;
    //                 credit.monthly_interest_optimized[i] = 0;
    //             }
    //         }
    //
    //     });
    // }
    // console.log(credits_sorted);

    return credits;
}

export function reset () {
    localStorage.removeItem('info');
    localStorage.removeItem('credits');
}

export function tooltip (node, options) {

    let component, hover;

    node.addEventListener('mouseover', attachTooltip);
    node.addEventListener('mouseout', removeTooltip);

    function attachTooltip () {
        component = new options.content({
            target: node,
            props: { text: options.text }
        });
    }

    function removeTooltip () {
        component.$destroy();
    }

    return {
        destroy () {
            node.removeEventListener('mouseover', attachTooltip);
            node.removeEventListener('mouseout', removeTooltip);
        }
    };
}
